import React from "react"
import { AppFunctionComponent } from "../../../types"
import { Path } from "../../constants/routes"
import { NeutralRawLink } from "../../../ui/components/link/link.styled"
import styled from "styled-components"
import { NavigationLink } from "../../types/navigation-link.interface"
import useTranslationHook from "../../../hooks/use-translation.hook"

const Separator = styled.span`
  display: none;
  color: #ddd;
  margin: 0 5px;
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: inline-block;
  }
`

const BreadcrumbLink = styled(NeutralRawLink)`
  font-weight: 400;
  font-size: ${12 / 16}rem;
  font-family: ${({ theme }) => theme.font.display};
  white-space: normal;
  display: none;

  &:hover {
    font-weight: 500;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: inline-block;
  }
`

const LinksList = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;

  li {
    white-space: nowrap;

    &:last-of-type {
      ${Separator} {
        display: none;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    margin-top: 23px;
  }
`

interface Props {
  links: Array<NavigationLink>
}

const Breadcrumbs: AppFunctionComponent<Props> = ({ links }) => {
  const { translate, dynamicTranslate } = useTranslationHook()
  return (
    <nav aria-label={"Breadcrumbs"}>
      <LinksList>
        <li>
          <BreadcrumbLink to={Path.Home}>{translate("Home")}</BreadcrumbLink>
          <Separator>/</Separator>
        </li>
        {links
          .filter((el) => el.title !== "Pl")
          .map((link) => {
            return (
              <li key={link.title}>
                <BreadcrumbLink to={link.url}>
                  {dynamicTranslate(link.title)}
                </BreadcrumbLink>
                <Separator>/</Separator>
              </li>
            )
          })}
      </LinksList>
    </nav>
  )
}

export default Breadcrumbs
